import { useEffect, useRef } from "react";

/** Lesson lists with this many items or fewer default to "list", otherwise "grid". */
export const DEFAULT_VIEW_MODE_LESSON_THRESHOLD = 12;

/**
 * Applies the default lesson view mode (list vs grid) based on lesson count,
 * but only once and only when the user has no stored preference yet.
 *
 * Mirrors the behaviour previously duplicated across SimpleCourseView and the
 * collection page.
 */
export function useDefaultLessonViewMode(
  viewModeLoaded: boolean,
  viewModeHadStored: boolean,
  lessonCount: number,
  setViewMode: (mode: "grid" | "list") => void,
): void {
  const appliedDefaultRef = useRef(false);

  useEffect(() => {
    if (
      !viewModeLoaded ||
      viewModeHadStored ||
      lessonCount === 0 ||
      appliedDefaultRef.current
    )
      return;
    appliedDefaultRef.current = true;
    setViewMode(
      lessonCount <= DEFAULT_VIEW_MODE_LESSON_THRESHOLD ? "list" : "grid",
    );
  }, [viewModeLoaded, viewModeHadStored, lessonCount, setViewMode]);
}
